import React, { useEffect, useState, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';

//Components
import MainCard from '../../components/MainCard/MainCard'
import FichaContainerPGRS from './components/FichaContainerPGRS'

//Context
import { useAuth } from '../../context/auth';

//Helpers
import { showMessage } from '../../helpers/message';

//API
import pgrs_api from '../../api/pgrs_api';
import NovoPGRS from './NovoPGRS';
import moment from 'moment';

export default function FichaPGRS({ id, btnVoltar, impressaoFicha = false }) {
    const { session, setLoading, setupVariavel } = useAuth();

    const [pgrs, setPgrs] = useState(null);
    //estado para edição dos dados do pgrs
    const [editar, setEditar] = useState(false);

    //Referencia para download do pdf
    const refRelatorio = useRef();

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Ficha de PGRS",
    });

    function loadGetItemPGRS(id) {
        setLoading(true);
        pgrs_api.GetItemPGRSGerador(id)
            .then(response => {
                if (response.data) {
                    response.data.tbFormularioPGRS_Id = response.data.tbFormularioPGRS_Id.toString();

                    if (response.data.contratosPendentes.length > 0) {
                        response.data.contratosPendentes = response.data.contratosPendentes
                            .map(contrato => {
                                contrato.checked = true;
                                contrato.contratoPendentePGRS = true;
                                return contrato
                            });
                    }
                }

                setPgrs(response.data)
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }


    function onSubmitAcoesGestor(acao) {
        setLoading(true);
        pgrs_api.InsertAcaoAnaliseGestor(acao)
            .then(response => showMessage("Sucesso", "Ação realizada com sucesso.", "success", btnVoltar))
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadGetItemPGRS(id)
    }, [id]);

    if (editar) {
        return <NovoPGRS
            pgrsItem={pgrs}
            btnVoltar={btnVoltar}
        />
    }

    return (
        <MainCard
            btnImprimir={impressaoFicha && (pgrs?.statusAnalise == "Aprovado" || pgrs?.statusAnalise == "Aprovado Automaticamente") ? handlePrint : null}
            btnVoltarInTop={impressaoFicha ? btnVoltar : null}
            btnVoltar={!impressaoFicha ? btnVoltar : null}
            btnEditar={session?.acesso?.sigla == "GS" || impressaoFicha == true ? null : () => setEditar(true)}
        >
            {pgrs &&
                <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                    {impressaoFicha &&
                        <>
                            <div className="print m-2 d-flex align-items-center justify-content-between">
                                <p>Emitido por: {session.nome}</p>
                                <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                            </div>
                            {setupVariavel?.logoTipo &&
                                <div className="d-flex align-items-center justify-content-center">
                                    <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
                                </div>
                            }
                        </>
                    }
                    <div className="body">
                        <FichaContainerPGRS
                            pgrs={pgrs}
                            finalizar={false}
                            onSubmitAcoesGestor={onSubmitAcoesGestor}
                            impressaoFicha={impressaoFicha}
                        />
                    </div>
                </div>
            }
        </MainCard>
    )
}
